module.exports = "https://cdn.hellotech.com/client-assets/routers_mobile_6346c8afc0e896239b72805ecac584cd.webp";